'use client';

import { useA11yStatusMessage } from '@vcc-package/a11y-status-message';
import { useSharedComponentsTranslate } from '@vcc-www/shared-dictionaries';
import type * as React from 'react';
import { useEffect } from 'react';
import type { Retailer } from '../types/retailer';

type RetailerListProps = {
  scrollRef?: React.RefObject<HTMLUListElement | null>;
  retailers: Retailer[];
  retailerCardRender: (retailer: Retailer) => React.ReactNode;
};

export const RetailerList = ({
  scrollRef,
  retailers,
  retailerCardRender,
}: RetailerListProps) => {
  const { setStatusMessage } = useA11yStatusMessage();
  const translate = useSharedComponentsTranslate();
  useEffect(() => {
    if (retailers.length === 0) return;
    setStatusMessage(
      translate('RetailerSelector.search.availableRetailersMessage', {
        count: retailers.length,
      }),
    );
  }, [retailers, setStatusMessage, translate]);

  return (
    <ul
      className="flex-col gap-16 relative"
      ref={scrollRef as React.RefObject<HTMLUListElement> | null}
    >
      {retailers.map((retailer) => (
        <li key={retailer.partnerId}>{retailerCardRender(retailer)}</li>
      ))}
    </ul>
  );
};
